<template>
  <div class="signing-checklist-selected-swap-file">
    <div class="d-flex align-center column-gap-4">
      <ClosdFildersIcon
        :document="displayedFile"
        :signed-file="displayedFile.signedOnClosd"
        small
        class="no-shrink"
      />
      <div class="signing-checklist-selected-swap-file__files flex-grow-1 min-w-0">
        <!-- Original file, struck through once a replacement has been picked -->
        <div class="d-flex align-center column-gap-2">
          <span class="body-md-bold text-truncated min-w-0"
                :class="selectedFile ? 'text-text-placeholder text-decoration-line-through' : 'text-text-secondary'"
          >
            {{ swapFile.title }}
          </span>
          <app-filesize-display v-if="originalFileSize"
                                class="detail-md-regular text-text-tertiary no-shrink"
                                :value="originalFileSize"
          />
        </div>
        <!-- Replacement file -->
        <div v-if="selectedFile" class="d-flex align-center column-gap-1">
          <span class="body-md-bold text-text-secondary text-truncated min-w-0">
            {{ selectedFile.objectToPost.fileName }}
          </span>
          <app-filesize-display v-if="selectedFile.size"
                                class="detail-md-regular text-text-tertiary no-shrink"
                                :value="selectedFile.size"
          />
          <app-material-icon v-if="selectedFile.status === 'success' || !selectedFile.objectToPost.fileRaw"
                             class="no-shrink"
                             color="icon-success"
                             name="check_circle"
                             filled
                             :size="16"
          />
        </div>
      </div>
      <div class="d-flex align-center column-gap-2 no-shrink">
        <slot></slot>
      </div>
    </div>
    <v-progress-linear
      v-if="isSelectedFileFromLocal"
      :model-value="selectedFile.progress"
      bg-color="grey-900"
      color="primary"
      height="6"
      rounded
    />
    <div>
      <app-toggle
        v-model="retainTags"
        hide-details="auto"
        :label="$t('project.signing-checklist.SwapFilesSelectorItem.retainTagsLabel')"
        :disabled="!selectedFile"
        @update:modelValue="onchangeRetainsTags"
      />
    </div>
  </div>
</template>

<script>
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'

export default {
  name: 'SwapFilesSelectorItem',
  components: {
    ClosdFildersIcon,
  },
  props: {
    selectedFile: {
      type: Object,
      default: () => {},
    },
    swapFile: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      retainTags: this.selectedFile?.objectToPost?.retainTags || true,
    }
  },
  computed: {
    displayedFile () {
      return this.selectedFile ? this.selectedFile : this.swapFile.envelope.file
    },
    originalFileSize () {
      return this.swapFile.envelope.file.size
    },
    isSelectedFileFromLocal () {
      return this.selectedFile && this.selectedFile.objectToPost.fileRaw
    },
  },
  methods: {
    onchangeRetainsTags () {
      this.selectedFile.objectToPost.retainTags = this.retainTags
      this.$emit('update-retain-tags', this.selectedFile)
    },
  },
  watch: {
    selectedFile () {
      if (this.selectedFile && this.selectedFile?.objectToPost?.retainTags !== this.retainTags) {
        this.onchangeRetainsTags()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.signing-checklist-selected-swap-file {
  display: flex;
  flex-direction: column;
  padding: 16px 24px 0 24px;
  overflow: hidden;
  background-color: rgb(var(--v-theme-surface-primary));
  border: get-border();
  @include border-radius('border-radius-4');

  &__files {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
  }
}
</style>
